import React from 'react';

const escapeRegExp = (string: string) => {
    return string.replace(/[$()*+.?[\\\]^{|}]/g, '\\$&');
};

export const highlightSearchTerm = (searchTerm: string, text: string) => {
    if (searchTerm) {
        const escapedSearchTerm = escapeRegExp(searchTerm);
        const searchTermRegex = new RegExp(`(${escapedSearchTerm})`, 'gi');

        return text
            ?.split(searchTermRegex)
            .map((segment, i) =>
                searchTermRegex.test(segment) ? (
                    <mark key={`${segment}-${i}`}>{segment}</mark>
                ) : (
                    segment
                )
            );
    }
    return text;
};
